<div class="popup-container" *ngIf="data.simpleFormButton || data.formDataId">
    <div class="popup-content">
        <div class="popup-actions">
            <i (click)="closePopup()" class="close-icon pi pi-times"></i>
        </div>
        <div class="popup-content">
            <app-fb-page-title-parent-action-button [pageFormType]="data.pageFormType"
            [formBuilderInfo]="data.formBuilderInfo"></app-fb-page-title-parent-action-button>
            <app-fb-simple-form [simpleFormButton]="data.simpleFormButton" [pageFormType]="data.pageFormType"
                [formTypeSelected]="data.formTypeSelected" [isFBModulePreview]="data.isFBModulePreview"
                [formBuilderInfo]="data.formBuilderInfo" [dataFormId]="data.formDataId"></app-fb-simple-form>
        </div>
    </div>
</div>